<template>
    <div id="settings-page">
        <div class="settings-partner-content"
             v-if="canEdit || (partnerExists)"
             v-bind:class="partnerLoading? 'disabled' : ''" style="z-index: 1001 !important;">
            <label class="select-partner-label">ORGANIZATION</label>
            <dropdown :data="dropdownData" :cbChanged="changed" class="select-partner-drop-down" :width="350"
                      placeholder="Loading..." :disabled="true"/>
            <button class="action-button edit-partner-button grow" @click="onEditPartnerClicked"
                    v-show="shouldDisplayUploadButton" v-if="!isDemo && shouldDisplayPartnerEditAdd">EDIT PARTNER
            </button>
            <button class="action-button add-partner-button grow" @click="onAddPartnerClicked"
                    v-show="shouldDisplayAddPartnerButton"
                    id="settings-page--add-partner-button"
                    v-if="!isDemo">
                ADD PARTNER
            </button>
            <loading-modal class="partner-loading-modal-container" v-if="partnerLoading"/>
        </div>
        <div class="settings-content">
            <tabs @changed="onTabChange"
                  :options="{ useUrlFragment: false, defaultTabHash: isPhoneModalGoToSettingsClicked ? 'account-tab' : 'domain-tab' }"
                  ref="tabsComponent"
                  v-if="permissionReqFinished">
                <tab id="domain-tab" name="DOMAIN LIST" v-if="showDomainList">
                    <data-table class="settings-datatable" v-blur="blur"
                                :dateColumns="[{column: 'create_date', isAsc: true, hideDateFilter: true}]"
                                :clientPagination="true"
                                :cols="domainColumns"
                                :url="domainUrl"
                                :orderBy="orderBy"
                                :dataPath="dataPath"
                                :requestParams="requestParams"
                                :settingsPermission="'301'"
                                @onDeleteClick="onDomainDeleteClick"
                                @loading="onLoading"
                                @loaded="onLoaded"
                                :tableName="'Domain List'"
                                :isSummaryVisible="false"
                                ref="domainListDatatable"
                                :pageContainerId="'domain-tab'"
                                :isSettingsPage="true"
                                :isStixExportAvailable="false"
                    ></data-table>
                    <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
                </tab>
                <tab id="ip-tab" name="IP LIST" :selected="true" v-if="showIpList">
                    <data-table class="settings-datatable" v-blur="blur"
                                :dateColumns="[{column: 'create_date', isAsc: true, hideDateFilter: true}]"
                                :clientPagination="true"
                                :cols="ipColumns"
                                :url="ipUrl"
                                :orderBy="orderBy"
                                :dataPath="dataPath"
                                :requestParams="requestParams"
                                :settingsPermission="'302'"
                                @onDeleteClick="onIPDeleteClick"
                                @loading="onLoading"
                                @loaded="onLoaded"
                                :tableName="'IP List'"
                                :isSummaryVisible="false"
                                ref="ipListDatatable"
                                :pageContainerId="'ip-tab'"
                                :isSettingsPage="true"
                                :isStixExportAvailable="false"
                    ></data-table>
                    <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
                </tab>
                <tab id="brand-tab" name="BRAND LIST" v-if="showBrandList">
                    <data-table class="settings-datatable" v-blur="blur"
                                :dateColumns="[{column: 'create_date', isAsc: true, hideDateFilter: true}]"
                                :clientPagination="true"
                                :cols="brandColumns"
                                :url="brandUrl"
                                :orderBy="orderBy"
                                :dataPath="dataPath"
                                :requestParams="requestParams"
                                :settingsPermission="'303'"
                                @onDeleteClick="onBrandDeleteClick"
                                @loading="onLoading"
                                @loaded="onLoaded" ref="brandListDatatable"
                                :isSummaryVisible="false"
                                :tableName="'Brand List'"
                                :pageContainerId="'brand-tab'"
                                :isSettingsPage="true"
                                :isStixExportAvailable="false"
                    ></data-table>
                    <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
                </tab>
                <tab id="vendor-tab" name="SECURITY VENDOR" v-if="showAntiVirusVendors">
                    <section id="secVendors">
                        <label class="av-vendor-radio-button container" v-for="vendor in av_vendors">{{vendor.name}}
                            <input type="radio" v-model="selected" :value="vendor.id">
                            <span class="checkmark"></span>
                        </label>
                    </section>
                    <button class="vendor-save-changes action-button-big grow"
                            @click="onSaveVendorButtonClicked">
                        SAVE CHANGES
                    </button>
                </tab>
                <tab id="account-tab" name="ACCOUNT LIST" v-if="showAccountList">
                    <div class="api-key-container">
                        <label class="api-key-header">API KEY : </label>
                        <label class="api-key-value">{{enterprise_api_key}}</label>
                    </div>
                    <div style="width:66%"></div>
                    <data-table class="settings-datatable" v-blur="blur"
                                :dateColumns="[{column: 'create_date', isAsc: true, hideDateFilter: true}]"
                                :clientPagination="true"
                                :cols="accountColumns"
                                :url="accountUrl"
                                :orderBy="orderBy"
                                :dataPath="dataPath"
                                :requestParams="requestParams"
                                :settingsPermission="'305'"
                                @onEditClick="onAccountEditClick"
                                @onDeleteClick="onAccountDeleteClick"
                                @loading="onLoading"
                                @loaded="onLoaded"
                                :tableName="'Account List'"
                                :isSummaryVisible="false"
                                ref="accountListDataTable"
                                :pageContainerId="'account-tab'"
                                :isSettingsPage="true"
                                :isStixExportAvailable="false"
                    ></data-table>

                    <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
                </tab>
                <tab id="notification-tab" name="NOTIFICATIONS" v-if="showNotification">
                    <data-table class="settings-datatable" v-blur="blur"
                                :dateColumns="[]"
                                :clientPagination="true"
                                :cols="notificationsColumns"
                                :url="notificationsUrl"
                                :orderBy="orderBy"
                                :dataPath="dataPath"
                                :requestParams="requestParams"
                                :hasTooltipColumn="true"
                                :settingsPermission="'306'"
                                @loading="onLoading"
                                @loaded="onLoaded"
                                @onEditClick="onNotificationEditClick"
                                @onDeleteClick="onNotificationDeleteClick"
                                :tableName="'Notifications List'"
                                :isSummaryVisible="false"
                                ref="notificationListDataTable"
                                :pageContainerId="'notification-tab'"
                                :isSettingsPage="true"
                                :isStixExportAvailable="false"
                    ></data-table>
                    <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
                </tab>
                <tab id="license-tab" name="LICENSES" v-if="showLicenseList">
                    <data-table class="settings-datatable" v-blur="blur"
                                :dateColumns="[{column: 'create_date', isAsc: true, hideDateFilter: true},
                                {column: 'start_date', isAsc: true, hideDateFilter: true},
                                {column: 'expiration_date', isAsc: true, hideDateFilter: true}]"
                                :clientPagination="true"
                                :cols="licensesColumns"
                                :url="licensesUrl"
                                :orderBy="orderBy"
                                :dataPath="dataPath"
                                :requestParams="requestParams"
                                :hasTooltipColumn="true"
                                :settingsPermission="'307'"
                                @loading="onLoading"
                                @loaded="onLoaded"
                                :tableName="'Licenses List'"
                                :isSummaryVisible="false"
                                ref="licenseListDataTable"
                                :pageContainerId="'licences-tab'"
                                :isSettingsPage="true"
                                :isStixExportAvailable="false"
                    ></data-table>
                    <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
                </tab>
            </tabs>
            <loading-modal class="loading-modal-container" v-if="!permissionReqFinished"></loading-modal>

            <button class="action-button upload-button grow" @click="onUploadButtonClicked"
                    v-show="shouldDisplayUploadButton && showUploadButton" v-if="!isDemo" :disabled="partnerLoading"
                    :id="partnerLoading ? 'disableAddButtons':''">UPLOAD CSV
            </button>
            <input type="file" id="fileInput" class="csv-upload-input" @change="getUploadedFile"
                   v-if="shouldDisplayUploadButton && !isDemo">
            <button class="action-button add-button grow" @click="onAddButtonClicked" v-show="shouldDisplayAddButton"
                    id="settings-add-button"
                    v-if="!isDemo" :disabled="partnerLoading" :id="partnerLoading ? 'disableAddButtons':''">
                ADD
            </button>
            <button class="action-button add-notification-button grow" @click="onNotificationAddClick"
                    v-show="shouldDisplayAddNotificationButton" v-if="!isDemo">ADD NEW NOTIFICATION
            </button>

            <add-settings-modal ref="addSettingsModal" :tableType="tableType" @saveClicked="saveClicked"
                                v-if="shouldDisplayUploadButton"/>
            <edit-account-settings ref="editAccountSettings" @operationCompleted="accountEditOperationCompleted"/>
            <edit-notification-settings ref="editNotificationSettings"
                                        @operationCompleted="notificationtEditCompleted"/>
            <confirm-popup-modal ref="confirmPopupModal" @okClicked="popUpConfirmClicked" :modalName="'settingsModal'"/>

            <partner-modal ref="partnerModal" @saveClicked="savePartnerClicked" @editClicked="editPartnerClicked"
                           @deleteClicked="deletePartnerClicked"/>
        </div>
    </div>
</template>

<script>

    import '@/assets/css/tabs.css'

    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import DataTable from '@/components/datatable/DataTable.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import AddSettingsModal from '@/components/modals/AddSettingsModal.vue'
    import EditAccountSettings from '@/components/modals/EditAccountSettings.vue'
    import EditNotificationSettings from '@/components/modals/EditNotificationSettings.vue'
    import {mapGetters} from 'vuex'
    import ConfirmPopupModal from '@/components/modals/ConfirmPopupModal.vue'
    import PartnerModal from '@/components/modals/PartnerModal.vue'

    //Tab Names
    const TAB_DOMAIN = 'DOMAIN LIST';
    const TAB_IP = 'IP LIST';
    const TAB_BRAND = 'BRAND LIST';
    const TAB_AV = 'SECURITY VENDOR';
    const TAB_ACC_LIST = 'ACCOUNT LIST';
    const TAB_NOTIFICATION = 'NOTIFICATIONS';
    const TAB_LICENSE = 'LICENSES';

    //Table Constants
    const TABLE_TYPE_DOMAIN = 1;
    const TABLE_TYPE_IP = 2;
    const TABLE_TYPE_BRAND = 3;
    const TABLE_TYPE_AV_VENDORS = 4;
    const TABLE_TYPE_ACCOUNT_LIST = 5;
    const TABLE_TYPE_NOTIFICATIONS = 6;
    const TABLE_TYPE_LICENSE = 7;

    //Regexs
    const DOMAIN_FORMAT = /^(([\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{1,})(-)?([\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{1,})?){1,}\.[\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{2,15}(\.[\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{2,})?$/;
    const IP_FORMAT = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    const URL_FORMAT = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/

    //End Point Constants
    //ADD
    const END_POINT_DOMAIN_ADD = "/enterprise/domain/insert";
    const END_POINT_IP_ADD = "/enterprise/ip/insert";
    const END_POINT_BRAND_ADD = "/enterprise/brand/insert";
    const END_POINT_LICENSE_KEY_ADD = "/insert_license_from_settings";
    //BULK
    const END_POINT_DOMAIN_ADD_BULK = "/enterprise/domain/bulk/insert";
    const END_POINT_IP_ADD_BULK = "/enterprise/ip/bulk/insert";
    const END_POINT_BRAND_ADD_BULK = "/enterprise/brand/bulk/insert";
    const END_POINT_NOTIFICATONS_GET = "/enterprise/notifications/get";
    //DELETE
    const END_POINT_DOMAIN_DELETE = "/enterprise/domain/delete";
    const END_POINT_IP_DELETE = "/enterprise/ip/delete";
    const END_POINT_BRAND_DELETE = "/enterprise/brand/delete";
    const END_POINT_ACCOUNT_DELETE = "/enterprise/account/delete";
    const END_POINT_NOTIFICATONS_DELETE = "/enterprise/notifications/delete";

    // PARTNER OPERATIONS
    const END_POINT_INSERT_PARTNER = '/enterprise/partner/insert';
    const END_POINT_UPDATE_PARTNER = '/enterprise/partner/update';
    const END_POINT_PARTNERS_GET = "/enterprise/partners/get";
    const END_POINT_DELETE_PARTNER = '/enterprise/partner/delete';
    //GET
    const END_POINT_AV_VENDORS_GET = "/antivirusvendor/get";
    const END_POINT_LICENSES_GET = "/enterprise/licenses/get";
    const END_POINT_ACCOUNT_GET = "/enterprise/account/get";
    const END_POINT_BRAND_GET = "/enterprise/brand/get";
    const END_POINT_IP_GET = "/enterprise/ip/get";
    const END_POINT_DOMAIN_GET = "/enterprise/domain/get";
    //UPDATE
    const END_POINT_AV_VENDORS_UPDATE = "/antivirusvendor/save";

    //Tab Permission Constants
    const TAB_PERM_DOMAIN = '301';
    const TAB_PERM_IP = '302';
    const TAB_PERM_BRAND = '303';
    const TAB_PERM_AV_VENDOR = '304';
    const TAB_PERM_ACCOUNT = '305';
    const TAB_PERM_NOTIFICATION = '306';
    const TAB_PERM_LICENSE = '307';
    export default {
        name: 'settings',
        components: {
            DataTable: DataTable,
            LoadingModal: LoadingModal,
            AddSettingsModal: AddSettingsModal,
            EditAccountSettings: EditAccountSettings,
            EditNotificationSettings: EditNotificationSettings,
            ConfirmPopupModal: ConfirmPopupModal,
            PartnerModal: PartnerModal
        },
        props: {
            isPhoneModalGoToSettingsClicked: {
                type: Boolean,
                required: false
            }
        },
        mixins: [Common],
        data() {
            return {
                av_vendors: [],
                selected: '',
                requestParams: {},
                loading: false,
                tableType: null,
                canEdit: true,
                deleteRequestData: null,
                bulkInsertEleminateCount: 0,
                pageName: 'Settings Page',
                log_start: Date.now(),

                //Tab Permissions
                showDomainList: false,
                showIpList: false,
                showBrandList: false,
                showAntiVirusVendors: false,
                showAccountList: false,
                showNotification: false,
                showLicenseList: false,
                showUploadButton: true,

                permissionReqFinished: false,
                dropdownData: [],
                partnerRelatedTab: true,
                partnerExists: false,
                selectedPartner: null,
                partnerLoading: false,
                enterprise_api_key: null,
                is_partner: false,

                deleteRequestStartIP: null,
                deleteRequestEndIP: null,
                deleteRequestBrandName: null,
                deleteRequestDomainName: null,
                deleteRequestAccountEmail: null,

                //Logs
                add_partner_cat_logger_data: null,
                edit_partner_cat_logger_data: null,
                willOpenEditAccountSettingsForPhoneNumber: false,
                checkedAccountListDataTableForPhone: false
            }
        },
        methods: {
            checkPhoneNumber() {
                if (this.isPhoneModalGoToSettingsClicked) {
                    this.willOpenEditAccountSettingsForPhoneNumber = true;
                }
            },
            adjustPermissions() {
                var apiKey = this.getApiKey;
                if (apiKey != undefined && apiKey != null && apiKey != 'None') {
                    this.enterprise_api_key = this.getApiKey;
                }
                var manName = this.getComodoAdminName;
                var isprimary = this.getIsPrimaryUser;
                if ((manName === undefined || manName === null || manName === '') && isprimary === "False") {
                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/permission/get')
                        .then(response => {
                            if (response.body.return_code === 'Success') {
                                var response_data = response.data.data;
                                var permittedTabs = response_data.settings_permissions.ui_permissions;

                                if (permittedTabs.indexOf(TAB_PERM_DOMAIN) != -1) {
                                    this.showDomainList = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_DOMAIN;
                                    }
                                }
                                if (permittedTabs.indexOf(TAB_PERM_IP) != -1) {
                                    this.showIpList = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_IP;
                                    }
                                }
                                if (permittedTabs.indexOf(TAB_PERM_BRAND) != -1) {
                                    this.showBrandList = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_BRAND;
                                    }
                                }
                                if (permittedTabs.indexOf(TAB_PERM_AV_VENDOR) != -1) {
                                    this.showAntiVirusVendors = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_AV_VENDORS;
                                    }
                                }
                                if (permittedTabs.indexOf(TAB_PERM_ACCOUNT) != -1) {
                                    this.showAccountList = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_ACCOUNT_LIST;
                                    }
                                }
                                if (permittedTabs.indexOf(TAB_PERM_NOTIFICATION) != -1) {
                                    this.showNotification = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_NOTIFICATIONS;
                                    }
                                }

                                if (permittedTabs.indexOf(TAB_PERM_LICENSE) != -1) {
                                    this.showLicenseList = true;
                                    if (this.tableType == null) {
                                        this.tableType = TABLE_TYPE_LICENSE;
                                    }
                                }

                                this.permissionReqFinished = true;
                                let settingsComponent = this;
                                setTimeout(() => {
                                    settingsComponent.checkPhoneNumber();
                                }, 1000);
                            }
                        }, response => {
                            this.permissionReqFinished = true;
                            let settingsComponent = this;
                            setTimeout(() => {
                                settingsComponent.checkPhoneNumber();
                            }, 1000);
                            this.$toasted.show("Request error, please try again.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        })
                } else {
                    this.showDomainList = true;
                    this.showIpList = true;
                    this.showBrandList = true;
                    this.showAntiVirusVendors = true;
                    this.showAccountList = true;
                    this.showNotification = true;
                    this.showLicenseList = true;
                    this.permissionReqFinished = true;
                    let settingsComponent = this;
                    setTimeout(() => {
                        settingsComponent.checkPhoneNumber();
                    }, 1000);
                }
            },
            savePartnerClicked(partnerObject) {
                var send_data = {
                    enterprise_name: partnerObject.partnerName,
                    enterprise_logo: partnerObject.partnerLogo,
                    enterprise_primary_domain: partnerObject.primaryDomain,
                    enterprise_industry: partnerObject.partnerIndustry
                };
                this.add_partner_cat_logger_data = send_data;
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + END_POINT_INSERT_PARTNER, send_data);
                promise.then(function (response) {
                    let enterprise_id = response.data.enterprise_id;
                    let partner_id = response.data.partner_id;
                    let current_enterprise_name = response.data.enterprise_name;
                    this.$refs.partnerModal.clearAndHideModal();
                    getPartners(this);
                    setTimeout(this.$refs.domainListDatatable.refresh, 0);
                    setTimeout(this.$refs.ipListDatatable.refresh, 0);
                    setTimeout(this.$refs.brandListDatatable.refresh, 0);

                    if (this.add_partner_cat_logger_data.enterprise_industry === null) {
                        this.add_partner_cat_logger_data.enterprise_industry = '';
                    }
                    this.add_partner_cat_logger_data.enterprise_id = enterprise_id;
                    this.add_partner_cat_logger_data.partner_id = partner_id;
                    this.add_partner_cat_logger_data.current_enterprise_name = current_enterprise_name;

                    this.saveCatLog(this, Constants.cat_logger.customer_ui_edit_account_cat_logger, this.add_partner_cat_logger_data)

                }, function () {
                    this.$toasted.show("Unable to insert new partner!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                    this.$refs.partnerModal.clearAndHideModal();

                });

            },
            editPartnerClicked(partnerObject) {
                // if(partnerObject.current_selected_industry_id == partnerObject.new_selected_industry_id) {
                //     partnerObject.new_selected_industry_id = null;
                // }
                var send_data = {
                    enterprise_id: partnerObject.partnerEnterpriseId,
                    enterprise_name: partnerObject.partnerName,
                    enterprise_logo: partnerObject.partnerLogo,
                    enterprise_primary_domain: partnerObject.primaryDomain,
                    enterprise_primary_domain_id: partnerObject.partnerPrimaryDomainId,
                    enterprise_selected_current_industry_id: partnerObject.current_selected_industry_id,
                    enterprise_selected_new_industry_id: partnerObject.new_selected_industry_id,
                    enterprise_internal_customer: false
                };
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + END_POINT_UPDATE_PARTNER, send_data);
                promise.then(function (response) {
                    this.edit_partner_cat_logger_data = send_data;
                    let current_enterprise_id = this.getEnterpriseId;
                    let current_enterprise_name = this.getComodoUserObject;
                    this.edit_partner_cat_logger_data.current_enterprise_id = current_enterprise_id;
                    this.edit_partner_cat_logger_data.current_enterprise_name = current_enterprise_name;
                    this.saveCatLog(this, Constants.cat_logger.customer_ui_edit_partner_cat_logger, this.edit_partner_cat_logger_data);
                    this.$refs.partnerModal.clearAndHideModal();
                    getPartners(this);
                    // todo do some refresh of tables and combobox here.
                    setTimeout(this.$refs.domainListDatatable.refresh, 0);
                    setTimeout(this.$refs.ipListDatatable.refresh, 0);
                    setTimeout(this.$refs.brandListDatatable.refresh, 0);
                }, function () {
                    this.$toasted.show("Unable to update new partner!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                    this.$refs.partnerModal.clearAndHideModal();
                });

            },
            deletePartnerClicked(partnerObject) {
                var send_data = {
                    enterprise_id: partnerObject.partnerEnterpriseId,
                };
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + END_POINT_DELETE_PARTNER, send_data);
                promise.then(function (response) {
                    this.$refs.partnerModal.clearAndHideModal();
                    getPartners(this);
                    setTimeout(this.$refs.domainListDatatable.refresh, 0);
                    setTimeout(this.$refs.ipListDatatable.refresh, 0);
                    setTimeout(this.$refs.brandListDatatable.refresh, 0);
                    this.adjustPermissions();
                }, function () {
                    this.$toasted.show("Unable to delete partner!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                    this.$refs.partnerModal.clearAndHideModal();
                });

            },
            checkIfTabAccessible() {
                if (this.tableType == TABLE_TYPE_ACCOUNT_LIST || this.tableType == TABLE_TYPE_AV_VENDORS || this.tableType == TABLE_TYPE_NOTIFICATIONS || this.tableType == TABLE_TYPE_LICENSE) {
                    this.$refs.tabsComponent.selectTab(this.$refs.tabsComponent.tabs[0].hash);
                }
            },
            changed(selected) {
                this.saveLog(this, this.pageName, ' Selected ' + '"' + selected[0].label + '"' + ' Partner', this.getDurationInSeconds(this.log_start, Date.now()), null);

                this.selectedPartner = selected[0];
                this.requestParams = {enterprise_id: this.selectedPartner.value};
                setTimeout(this.$refs.domainListDatatable.refresh, 0);
                setTimeout(this.$refs.ipListDatatable.refresh, 0);
                setTimeout(this.$refs.brandListDatatable.refresh, 0);
                if (this.selectedPartner.value != this.getEnterpriseId) {
                    this.showAccountList = false;
                    this.showAntiVirusVendors = false;
                    this.showNotification = false;
                    this.showLicenseList = false;
                    this.is_partner = true;
                    this.checkIfTabAccessible();
                } else {
                    this.showAccountList = true;
                    this.showAntiVirusVendors = true;
                    this.showNotification = true;
                    this.showLicenseList = true;
                    this.is_partner = false;
                }
            },
            onLoading() {
                // this.loading = true;
            },
            onLoaded() {
                this.loading = false;
                if (this.willOpenEditAccountSettingsForPhoneNumber) {
                    if (!this.checkedAccountListDataTableForPhone) {
                        if (this.$refs.accountListDataTable.tableData.length) {
                            this.$emit("changeIsPhoneModalGoToSettingsClicked");
                            this.checkedAccountListDataTableForPhone = true;
                            let rowWillBeClicked = this.$refs.accountListDataTable.tableData.filter(oneData => oneData.email === this.getComodoUserObject)[0];
                            this.onAccountEditClick(rowWillBeClicked);
                            let settingsComponent = this;
                            setTimeout(function () {
                                settingsComponent.$refs.editAccountSettings.$refs.editAccountSettingsPhoneInput.focus();
                            }, 1000);
                        }
                    }
                }
            },
            onDomainDeleteClick(row) {
                if (row.isprimary === 'True') {
                    this.$toasted.show("Primary domains cannot be deleted.", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                } else {
                    this.deleteRequestData = row.enterprise_domain_id;
                    this.deleteRequestDomainName = row.domain_name;
                    this.$refs.confirmPopupModal.showModal('Are you sure to delete domain?');
                }
            },
            onIPDeleteClick(row) {
                this.deleteRequestData = row.enterprise_ip_id;
                this.deleteRequestStartIP = row.start_ip;
                this.deleteRequestEndIP = row.end_ip;
                this.$refs.confirmPopupModal.showModal('Are you sure to delete ip?');
            },
            onBrandDeleteClick(row) {
                this.deleteRequestBrandName = row.name;
                this.deleteRequestData = row.id;
                this.$refs.confirmPopupModal.showModal('Are you sure to delete brand?');
            },
            onNotificationEditClick(row) {
                this.$refs.editNotificationSettings.showModal(row, false);
            },
            onNotificationAddClick() {
                this.$refs.editNotificationSettings.showModal(null, true);
            },
            onNotificationDeleteClick(row) {
                let send_data = {
                    type: row.type,
                    feed_id: row.feed_enum,
                    notification_id: row.id
                };
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + END_POINT_NOTIFICATONS_DELETE, send_data);
                promise.then(function (response) {
                    let cat_logger_data = {
                        threat_type: row.feed_name,
                        notification: row.type_name,
                        notification_id: row.type,
                        customer_id: this.getEnterpriseId,
                        customer_name: this.getEnterpriseName
                    };
                    this.saveCatLog(this, Constants.cat_logger.customer_ui_delete_notification_cat_logger, cat_logger_data);
                    this.$refs.notificationListDataTable.refresh();
                }, function () {
                    this.$refs.notificationListDataTable.refresh();
                    this.$toasted.show("Unable to delete notification!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                });
            },
            onAccountEditClick(row) {
                this.$refs.editAccountSettings.showModal(row);
            },
            onAccountDeleteClick(row) {
                if (row.isprimary === 'True') {
                    this.$toasted.show("Primary users cannot be deleted.", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                } else {
                    this.deleteRequestData = row.id;
                    this.deleteRequestAccountEmail = row.email;
                    this.$refs.confirmPopupModal.showModal('Are you sure to delete account?');
                }
            },
            onAddButtonClicked() {
                if (this.tableType == TABLE_TYPE_ACCOUNT_LIST) {
                    this.$refs.editAccountSettings.showModal(null);
                } else {
                    this.$refs.addSettingsModal.isAddButtonDisabled = false;
                }
                this.$refs.addSettingsModal.showModal();
            },
            onUploadButtonClicked() {
                document.getElementById('fileInput').click();
            },
            onEditPartnerClicked() {
                this.$refs.partnerModal.showModal("edit", this.selectedPartner.value, this.selectedPartner.label,
                    this.selectedPartner.primary_domain, this.selectedPartner.logo, this.selectedPartner.partnerPrimaryDomainId, this.selectedPartner.current_industry_id);
            },
            onAddPartnerClicked() {
                this.$refs.partnerModal.showModal("add", null, null, null, null, null);
            },
            onTabChange(data) {
                if (data.tab.name == TAB_DOMAIN) {
                    this.tableType = TABLE_TYPE_DOMAIN;
                    this.partnerRelatedTab = true;
                    this.showUploadButton = true;
                } else if (data.tab.name == TAB_IP) {
                    this.tableType = TABLE_TYPE_IP;
                    this.partnerRelatedTab = true;
                    this.showUploadButton = true;
                } else if (data.tab.name == TAB_BRAND) {
                    this.tableType = TABLE_TYPE_BRAND;
                    this.partnerRelatedTab = true;
                    this.showUploadButton = true;
                } else if (data.tab.name == TAB_AV) {
                    this.tableType = TABLE_TYPE_AV_VENDORS;
                    this.partnerRelatedTab = false;
                    this.showUploadButton = true;
                } else if (data.tab.name == TAB_ACC_LIST) {
                    this.tableType = TABLE_TYPE_ACCOUNT_LIST;
                    this.partnerRelatedTab = false;
                    this.showUploadButton = true;
                } else if (data.tab.name == TAB_NOTIFICATION) {
                    this.tableType = TABLE_TYPE_NOTIFICATIONS;
                    this.partnerRelatedTab = false;
                    this.showUploadButton = true;
                } else if (data.tab.name == TAB_LICENSE) {
                    this.tableType = TABLE_TYPE_LICENSE;
                    this.partnerRelatedTab = true;
                    this.showUploadButton = false;
                } else {
                    this.tableType = '';
                    this.partnerRelatedTab = false;
                    this.showUploadButton = true;
                }
            },
            getUploadedFile(event) {
                var file = event.target.files[0];
                document.getElementById("fileInput").value = "";
                if (file.name != undefined && file.name != null && file.name.indexOf('.csv') != -1) {
                    readCSV(this, file, this.tableType);
                } else {

                    this.$toasted.show("File is not in correct format, please add csv file!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            accountEditOperationCompleted() {
                this.$refs.accountListDataTable.refresh();
            },
            ip2int(ip) {
                return ip.split('.').reduce(function (ipInt, octet) {
                    return (ipInt << 8) + parseInt(octet, 10)
                }, 0) >>> 0;
            },
            notificationtEditCompleted(data) {
                this.$refs.notificationListDataTable.refresh();

                if (data.success == false) {
                    this.$toasted.show(data.msg, {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            saveClicked(data) {
                if (data.tableType == TABLE_TYPE_DOMAIN) {
                    // console.log("save clicked --> " + data.domainName);
                    var domain = data.domainName.trim().toLowerCase();
                    if (domain != undefined && domain != null && domain != ''
                        && !IP_FORMAT.test(domain) && !URL_FORMAT.test(domain) && !domain.includes(":") && !domain.includes("/") && !domain.includes("\\") && DOMAIN_FORMAT.test(domain)) {
                        if (!isDomainAlreadyExists(this.$refs.domainListDatatable.getTableData(), domain)) {
                            // todo: Disable buttons
                            var body = {
                                domain_name: domain,
                                enterprise_id: this.selectedPartner.value,
                                is_partner: this.is_partner
                            };
                            addRequest(this, data.tableType, END_POINT_DOMAIN_ADD, body);
                        } else {
                            this.$toasted.show('Domain already exists!', {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    } else {
                        this.$toasted.show("Please enter valid domain!", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                } else if (data.tableType == TABLE_TYPE_IP) {
                    var startIp = data.startIp;
                    var endIp = data.endIp;
                    // console.log("save clicked --> " + startIp + " , " + endIp);
                    var isParamsValid = true;
                    if ((startIp == undefined || startIp == '') && (endIp != undefined && endIp != '')) {
                        startIp = endIp;
                    }
                    if ((endIp == undefined || endIp == '') && (startIp != undefined && startIp != '')) {
                        endIp = startIp;
                    }
                    if (!startIp.match(IP_FORMAT) || !endIp.match(IP_FORMAT)) {
                        isParamsValid = false;
                        this.$toasted.show("IP parameters are not valid. Please check IP parameters and retry!", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                    if (isParamsValid) {
                        let startIpInt = this.ip2int(startIp);
                        let endIpInt = this.ip2int(endIp);
                        var startIpValues = startIp.split(".");
                        var endIpValues = endIp.split(".");
                        if (startIpValues.length == endIpValues.length) {
                            if (startIpInt > endIpInt) {
                                this.$toasted.show("End IP must bigger than or equal to StartIP. Please check IP parameters and retry.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                                isParamsValid = false;
                            }
                            // var len = startIpValues.length;
                            // for (var i = 0; i < len; i++) {
                            //     if (parseInt(startIpValues[i]) > parseInt(endIpValues[i])) {
                            //         isParamsValid = false;
                            //         this.$toasted.show("End IP must bigger than or equal to StartIP. Please check IP parameters and retry.", {
                            //             position: "bottom-center",
                            //             duration: 5000,
                            //             type: 'error'
                            //         });
                            //         break;
                            //     }
                            // }
                        } else {
                            isParamsValid = false;
                            this.$toasted.show("IP parameters are not valid. Please check IP parameters and retry.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    }

                    if (isParamsValid) {
                        if (!checkCandidateIpIsExists(this.$refs.ipListDatatable.getTableData(), startIp, endIp)) {
                            var body = {
                                start_ip: startIp,
                                end_ip: endIp,
                                enterprise_id: this.selectedPartner.value,
                                is_partner: this.is_partner
                            };
                            addRequest(this, data.tableType, END_POINT_IP_ADD, body, startIp, endIp);
                        } else {
                            this.$toasted.show("IP range already exists.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    }
                } else if (data.tableType == TABLE_TYPE_BRAND) {
                    // console.log("save clicked --> " + data.brandName);
                    var brand = data.brandName.trim().toLowerCase();
                    if (brand != undefined && brand != null && brand != '') {
                        if (!isBrandAlreadyExists(this.$refs.brandListDatatable.getTableData(), brand)) {
                            // todo: Disable buttons
                            var body = {
                                name: brand,
                                enterprise_id: this.selectedPartner.value,
                                is_partner: this.is_partner
                            };
                            addRequest(this, data.tableType, END_POINT_BRAND_ADD, body);
                        } else {
                            this.$toasted.show("Brand already exists.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    } else {
                        this.$toasted.show("Please enter valid brand.", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                } else if (data.tableType == TABLE_TYPE_LICENSE) {
                    // console.log("save clicked --> " + data.brandName);
                    var licenseKey = data.licenseKey.trim().toLowerCase();
                    if (licenseKey != undefined && licenseKey != null && licenseKey != '') {
                        // todo: Disable buttons
                        var body = {
                            license_key: licenseKey
                        };
                        addRequest(this, data.tableType, END_POINT_LICENSE_KEY_ADD, body);
                    } else {
                        this.$toasted.show("Please enter valid license key.", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                } else {
                    this.$toasted.show("Wrong table selected.", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            onSaveVendorButtonClicked() {
                var body = {
                    vendors: this.selected.toString()
                }
                addRequest(this, TABLE_TYPE_AV_VENDORS, END_POINT_AV_VENDORS_UPDATE, body);
            },
            popUpConfirmClicked() {
                this.$refs.confirmPopupModal.hideModal();
                if (this.tableType == TABLE_TYPE_DOMAIN) {
                    deleteRequest(this, this.tableType, END_POINT_DOMAIN_DELETE, this.deleteRequestData);
                } else if (this.tableType == TABLE_TYPE_IP) {
                    deleteRequest(this, this.tableType, END_POINT_IP_DELETE, this.deleteRequestData);
                } else if (this.tableType == TABLE_TYPE_BRAND) {
                    deleteRequest(this, this.tableType, END_POINT_BRAND_DELETE, this.deleteRequestData);
                } else if (this.tableType == TABLE_TYPE_ACCOUNT_LIST) {
                    deleteRequest(this, this.tableType, END_POINT_ACCOUNT_DELETE, this.deleteRequestData);
                }
            }
        },
        computed: {
            accountColumns() {
                if (!this.isDemo) {
                    return [
                        {
                            column: "email",
                            title: "E-MAIL",
                            class: "col-20"
                        },
                        {
                            column: "first_name",
                            title: "FIRST NAME",
                            class: "col-20"
                        },
                        {
                            column: "last_name",
                            title: "LAST NAME",
                            class: "col-20"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-15"
                        },
                        {
                            column: "isprimary",
                            title: "PRIMARY",
                            class: "col-10"
                        },
                        {
                            column: "editDeleteRow",
                            title: "ACTIONS",
                            class: "col-15"
                        }
                    ]
                } else {
                    return [
                        {
                            column: "email",
                            title: "E-MAIL",
                            class: "col-25"
                        },
                        {
                            column: "first_name",
                            title: "FIRST NAME",
                            class: "col-25"
                        },
                        {
                            column: "last_name",
                            title: "LAST NAME",
                            class: "col-20"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-20"
                        },
                        {
                            column: "isprimary",
                            title: "PRIMARY",
                            class: "col-10"
                        }
                    ]
                }
            },
            domainColumns() {
                if (this.canEdit) {
                    return [
                        {
                            column: "domain_name",
                            title: "DOMAIN NAME",
                            class: "col-35"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-35"
                        },
                        {
                            column: "isprimary",
                            title: "IS PRIMARY",
                            class: "col-15"
                        },
                        {
                            column: "deleteRow",
                            title: "ACTIONS",
                            class: "col-15"
                        }
                    ]
                } else {
                    return [
                        {
                            column: "domain_name",
                            title: "DOMAIN NAME",
                            class: "col-40"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-40"
                        },
                        {
                            column: "isprimary",
                            title: "IS PRIMARY",
                            class: "col-20"
                        }
                    ]
                }
            },
            ipColumns() {
                if (this.canEdit) {
                    return [
                        {
                            column: "start_ip",
                            title: "START IP",
                            class: "col-30"
                        },
                        {
                            column: "end_ip",
                            title: "END IP",
                            class: "col-30"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-25"
                        },
                        {
                            column: "deleteRow",
                            title: "ACTIONS",
                            class: "col-15"
                        }
                    ]
                } else {
                    return [
                        {
                            column: "start_ip",
                            title: "START IP",
                            class: "col-35"
                        },
                        {
                            column: "end_ip",
                            title: "END IP",
                            class: "col-35"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-30"
                        }
                    ]
                }
            },
            brandColumns() {
                if (this.canEdit) {
                    return [
                        {
                            column: "name",
                            title: "BRAND NAME",
                            class: "col-55"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-30"
                        },
                        {
                            column: "deleteRow",
                            title: "ACTIONS",
                            class: "col-15"
                        }
                    ]
                } else {
                    return [
                        {
                            column: "name",
                            title: "BRAND NAME",
                            class: "col-65"
                        },
                        {
                            column: "create_date",
                            title: "CREATE DATE",
                            class: "col-35"
                        }
                    ]
                }
            },
            notificationsColumns() {
                if (!this.isDemo) {
                    return [
                        {
                            column: "feed_name",
                            title: "Threat Type",
                            class: "col-30"
                        },
                        {
                            column: "type_name",
                            title: "Notification Method",
                            class: "col-20"
                        },
                        {
                            column: "userCountTooltip",
                            title: "Recipient(s)",
                            template: "tooltip",
                            class: "col-20 text-right user_count"
                        },
                        {
                            column: "editDeleteRow",
                            title: "Actions",
                            class: "col-30 text-center"
                        }
                    ]
                } else {
                    return [
                        {
                            column: "feed_name",
                            title: "Threat Type",
                            class: "col-40"
                        },
                        {
                            column: "type_name",
                            title: "Notification Method",
                            class: "col-30"
                        },
                        {
                            column: "userCountTooltip",
                            title: "Recipient(s)",
                            template: "tooltip",
                            class: "col-30 text-right user_count"
                        }
                    ]
                }
            },
            licensesColumns() {
                return [
                    {
                        column: "id",
                        title: "License ID",
                        class: "col-25"
                    },
                    {
                        column: "create_date",
                        title: "Creation Date",
                        class: "col-15"
                    },
                    {
                        column: "license_type",
                        title: "License Type",
                        class: "col-15"
                    },
                    {
                        column: "start_date",
                        title: "License Start Date",
                        class: "col-15"
                    },
                    {
                        column: "expiration_date",
                        title: "License End Date",
                        class: "col-15"
                    },
                    {
                        column: "is_active",
                        title: "License Status",
                        class: "col-15"
                    }
                ]
            },
            domainUrl() {
                return Constants.INTELLIGENCE_BACKEND_URL + END_POINT_DOMAIN_GET;
            },
            ipUrl() {
                return Constants.INTELLIGENCE_BACKEND_URL + END_POINT_IP_GET;
            },
            brandUrl() {
                return Constants.INTELLIGENCE_BACKEND_URL + END_POINT_BRAND_GET;
            },
            accountUrl() {
                return Constants.INTELLIGENCE_BACKEND_URL + END_POINT_ACCOUNT_GET;
            },
            notificationsUrl() {
                return Constants.INTELLIGENCE_BACKEND_URL + END_POINT_NOTIFICATONS_GET;
            },
            licensesUrl() {
                return Constants.INTELLIGENCE_BACKEND_URL + END_POINT_LICENSES_GET;
            },
            orderBy() {
                return {
                    column: "create_date",
                    ascending: false
                }
            },
            blur() {
                return {
                    isBlurred: this.loading,
                    opacity: 0.3,
                    filter: 'blur(4px)',
                    transition: 'all .5s linear'
                }
            },
            dataPath() {
                if (this.isGlobal) {
                    return 'data.records';
                } else {
                    return 'data';
                }
            },
            isDemo() {
                return Constants.DEMO
            },
            shouldDisplayUploadButton() {
                if (this.canEdit) {
                    if (this.tableType == TABLE_TYPE_DOMAIN && this.showDomainList) {
                        return true;
                    } else if (this.tableType == TABLE_TYPE_IP && this.showIpList) {
                        return true;
                    } else if (this.tableType == TABLE_TYPE_BRAND && this.showBrandList) {
                        return true;
                    } else if (this.tableType == TABLE_TYPE_LICENSE && this.showLicenseList) {
                        return true;
                    }
                }
                return false;
            },
            shouldDisplayAddButton() {
                if (this.tableType == TABLE_TYPE_ACCOUNT_LIST && this.showAccountList) {
                    return true;
                } else if (this.canEdit) {
                    if (this.tableType == TABLE_TYPE_DOMAIN && this.showDomainList) {
                        return true;
                    } else if (this.tableType == TABLE_TYPE_IP && this.showIpList) {
                        return true;
                    } else if (this.tableType == TABLE_TYPE_BRAND && this.showBrandList) {
                        return true;
                    } else if (this.tableType == TABLE_TYPE_LICENSE && this.showLicenseList) {
                        return true;
                    }
                }
                return false;
            },
            shouldDisplayAddPartnerButton() {
                // if (this.canEdit){
                //     return this.partnerRelatedTab && (this.partnerExists) || !this.is_partner;
                // }
                // return false;
                return this.canEdit;
            },
            shouldDisplayPartnerEditAdd() {
                return this.canEdit && (this.selectedPartner == null ? false : (this.selectedPartner.value != this.getEnterpriseId));
            },
            shouldDisplayAddNotificationButton() {
                return this.tableType == TABLE_TYPE_NOTIFICATIONS && this.showNotification;
            },
            ...mapGetters([
                "getComodoAdminRole",
                "getEnterpriseStatus",
                "getComodoAdminName",
                "getIsPrimaryUser",
                "getEnterpriseId",
                "getEnterpriseName",
                "getApiKey",
                "getComodoUserObject"
            ])
        },
        beforeMount() {
            this.adjustPermissions();
            getPartners(this);
        },
        mounted() {
            canUserEdit(this, this.getComodoAdminName, this.getComodoAdminRole, this.getEnterpriseStatus);
            getRequest(this, TABLE_TYPE_AV_VENDORS, END_POINT_AV_VENDORS_GET);
        }
    }

    function canUserEdit(self, manName, manRole, entStatus) {
        if (manName === undefined || manName === null || manName === '' || Constants.DEMO) {
            self.canEdit = false;
        } else {
            manRole = self.getUserRole(manRole);
            entStatus = self.getStatus(entStatus);
            if (manRole == 'TI_ACCOUNT_MANAGER_RSM' || manRole == 'TI_SALES/SALES_ENGINEER' ||
                manRole == 'TI_SALES/SALES_ENGINEER' || manRole == 'TI_SALES/SALES_ENGINEER') {
                if (entStatus == 'POC') {
                    self.canEdit = false;
                }
            }
        }
    }

    function getPartners(self) {
        self.partnerLoading = true;
        var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + END_POINT_PARTNERS_GET);
        promise.then(function (response) {
                if (response.data.data.length > 0) {

                    this.partnerExists = response.data.data.length > 1;

                    self.dropdownData = [];
                    let selected = false;
                    response.data.data.forEach(function (d) {
                        var label = d['customer_name'];
                        if (d['customer_id'] == self.getEnterpriseId) {
                            label = label + '  (Master Account)';
                        } else {
                            label = label + '  (Partner Account)';
                        }
                        var data = {
                            label: label, value: d['customer_id'], selected: false,
                            logo: d['customer_logo'],
                            customer_name: d['customer_name'],
                            primary_domain: d['customer_primary_domain'],
                            partnerPrimaryDomainId: d['enterprise_primary_domain_id'],
                            current_industry_id: d['current_industry_id']
                        };
                        if (self.selectedPartner && self.selectedPartner.value === data.value) {
                            data.selected = true;
                            self.selectedPartner = data;
                            selected = true;
                        }
                        self.dropdownData.push(data);
                    });

                    if (!self.selectedPartner || !selected) {
                        self.dropdownData[0]["selected"] = true;
                        self.selectedPartner = self.dropdownData[0];
                    }
                } else {
                    this.partnerExists = false;
                }

                self.partnerLoading = false;
            },

            function () {
                self.partnerLoading = false;
            }
        )
    }

    function getRequest(self, tableType, getEndPoint) {
        var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + getEndPoint);
        promise.then(function (response) {
            if (tableType == TABLE_TYPE_AV_VENDORS) {
                var vendorData = response.data.data;
                for (var i = 0; i < vendorData.length; i++) {
                    if (vendorData[i].isChecked) {
                        self.selected = vendorData[i].id;
                    }
                }
                self.av_vendors = response.data.data;
            }
        }, function () {
            var message = '';
            if (tableType == TABLE_TYPE_AV_VENDORS) {
                message = 'Antivirus Vendors Can Not Be Taken';
            }
            this.$toasted.show(message, {
                position: "bottom-center",
                duration: 5000,
                type: 'error'
            });
        });
    }

    function addRequest(self, tableType, addEndPoint, body) {
        var send_data = {
            customer_name: self.getEnterpriseName,
            partner_name: self.getEnterpriseName != self.selectedPartner.customer_name ? self.selectedPartner.customer_name : '',
            partner_id: self.getEnterpriseId != self.selectedPartner.value ? self.selectedPartner.value : '',
            customer_id: self.getEnterpriseId
        };

        self.partnerLoading = true;
        var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + addEndPoint, body);
        promise.then(function (response) {
            self.partnerLoading = false;
            if (response.data.return_code == 'Unauthorized User') {
                this.$toasted.show('User is not have permission to add domain.', {
                    position: "bottom-center",
                    duration: 5000,
                    type: 'error'
                });
            } else {
                if (tableType != TABLE_TYPE_AV_VENDORS) {
                    self.$refs.addSettingsModal.clearAndHideModal();
                }

                if (isBulkRequest(response.url)) {
                    prepareBulkInsertAlert(self, response.data.data);
                } else {
                    if (tableType == TABLE_TYPE_LICENSE) {
                        self.$toasted.show("Licence added/updated on Intellgence", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'success'
                        });
                    } else {
                        if (response.body.return_code == "Domain is not unique.") {
                            self.$toasted.show("Warning: " + response.body.domain + " is previously used for " + response.body.enterprise_name + " enterprise. Please continue with the existing customer.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else if (response.body.return_code == "Success") {
                            self.$toasted.show("Successfull Saved", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'success'
                            });
                        } else {
                            self.$toasted.show("Successfully Saved", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'success'
                            });
                        }
                    }
                }

                if (tableType == TABLE_TYPE_DOMAIN) {
                    self.$refs.domainListDatatable.refresh();
                    if (addEndPoint == END_POINT_DOMAIN_ADD) {
                        send_data.domain_name = body.domain_name;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_add_domain_cat_logger, send_data);
                    }
                } else if (tableType == TABLE_TYPE_IP) {
                    self.$refs.ipListDatatable.refresh();
                    if (addEndPoint == END_POINT_IP_ADD) {
                        send_data.start_ip = body.start_ip;
                        send_data.end_ip = body.end_ip;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_add_ip_cat_logger, send_data);
                    }
                } else if (tableType == TABLE_TYPE_BRAND) {
                    this.$refs.brandListDatatable.refresh();
                    if (addEndPoint == END_POINT_BRAND_ADD) {
                        send_data.brand_name = body.name;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_add_brand_cat_logger, send_data);
                    }
                } else if (tableType == TABLE_TYPE_LICENSE) {
                    this.$refs.licenseListDataTable.refresh();
                } else if (tableType == TABLE_TYPE_AV_VENDORS) {
                    send_data.vendor_name = this.av_vendors.filter(data => data.id === this.selected)[0].name;
                    this.saveCatLog(this, Constants.cat_logger.customer_ui_security_vendor_cat_logger, send_data);
                }
            }
        }, function (response) {
            self.partnerLoading = false;
            if (isBulkRequest(response.url)) {
                prepareBulkInsertAlert(self, response.data.data);
            } else {
                var message = '';
                if (tableType == TABLE_TYPE_DOMAIN) {
                    message = 'Domain Can Not Be Saved';
                } else if (tableType == TABLE_TYPE_IP) {
                    if (response.body.message)
                        message = response.body.message;
                    else
                        message = 'IP Can Not Be Saved';
                } else if (tableType == TABLE_TYPE_BRAND) {
                    message = 'Brand Can Not Be Saved';
                } else if (tableType == TABLE_TYPE_AV_VENDORS) {
                    message = 'Antivirus Vendor Can Not Be Saved';
                } else if (tableType == TABLE_TYPE_LICENSE) {
                    message = 'License not found on CAM'
                }
                self.$toasted.show(message, {
                    position: "bottom-center",
                    duration: 5000,
                    type: 'error'
                });
            }
        });
    }

    function deleteRequest(self, tableType, deleteEndPoint, id) {
        var body = {
            id: id
        };

        var send_data = {
            customer_name: self.getEnterpriseName,
            partner_name: self.getEnterpriseName != self.selectedPartner.customer_name ? self.selectedPartner.customer_name : '',
            partner_id: self.getEnterpriseId != self.selectedPartner.value ? self.selectedPartner.value : '',
            customer_id: self.getEnterpriseId
        };

        var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + deleteEndPoint, body);
        promise.then(function (response) {
            if (response.data.return_code == 'Unauthorized User') {
                self.$toasted.show('User is not have permission to add domain.', {
                    position: "bottom-center",
                    duration: 5000,
                    type: 'error'
                });
            } else {
                self.$toasted.show("Successfully Deleted", {
                    position: "bottom-center",
                    duration: 5000,
                    type: 'success'
                });
                if (tableType == TABLE_TYPE_DOMAIN) {
                    self.$refs.domainListDatatable.refresh();
                    if (deleteEndPoint == END_POINT_DOMAIN_DELETE) {
                        send_data.domain_name = self.deleteRequestDomainName;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_delete_domain_cat_logger, send_data);
                    }
                } else if (tableType == TABLE_TYPE_IP) {
                    self.$refs.ipListDatatable.refresh();
                    if (deleteEndPoint == END_POINT_IP_DELETE) {
                        send_data.start_ip = self.deleteRequestStartIP;
                        send_data.end_ip = self.deleteRequestEndIP;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_delete_ip_cat_logger, send_data);
                    }
                } else if (tableType == TABLE_TYPE_BRAND) {
                    self.$refs.brandListDatatable.refresh();
                    if (deleteEndPoint == END_POINT_BRAND_DELETE) {
                        send_data.brand_name = self.deleteRequestBrandName;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_delete_brand_cat_logger, send_data);
                    }
                } else if (tableType == TABLE_TYPE_ACCOUNT_LIST) {
                    if (deleteEndPoint == END_POINT_ACCOUNT_DELETE) {
                        send_data.deleted_account_id = body.id;
                        send_data.deleted_email = self.deleteRequestAccountEmail;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_delete_account_cat_logger, send_data);
                    }
                    self.$refs.accountListDataTable.refresh();
                } else if (tableType == TABLE_TYPE_LICENSE) {
                    self.$refs.licenseListDataTable.refresh();
                }
            }
        }, function (response) {
            var message = '';
            if (tableType == TABLE_TYPE_DOMAIN) {
                message = 'Domain Can Not Be Deleted';
            } else if (tableType == TABLE_TYPE_IP) {
                message = 'IP Can Not Be Deleted';
            } else if (tableType == TABLE_TYPE_BRAND) {
                message = 'Brand Can Not Be Deleted';
            } else if (tableType == TABLE_TYPE_ACCOUNT_LIST) {
                message = 'Account Can Not Be Deleted';
            } else if (tableType == TABLE_TYPE_LICENSE) {
                message = 'License Can Not Be Deleted';
            }
            self.$toasted.show(message, {
                position: "bottom-center",
                duration: 5000,
                type: 'error'
            });
        });
    }

    function isBulkRequest(requestUrl) {
        if (requestUrl.indexOf('bulk') != -1) {
            return true;
        } else {
            return false;
        }
    }

    function prepareBulkInsertAlert(self, response_data) {
        var message = '';
        var errorCount = response_data.error_count;
        if (errorCount > 0) {
            message = message.concat(response_data.success_count).concat(' rows inserted.\n ')
                .concat(errorCount).concat(' rows not inserted.');
            self.$toasted.show(message, {
                position: "bottom-center",
                duration: 5000,
                type: 'error'
            });
        } else {
            message = message.concat(response_data.success_count).concat(' rows inserted.');
            self.$toasted.show(message, {
                position: "bottom-center",
                duration: 5000,
                type: 'success'
            });
        }
    }

    function isDomainAlreadyExists(list, candidate) {
        var response = false;
        if (list != undefined && list != null && list.length > 0) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].domain_name === candidate) {
                    response = true;
                    break;
                }
            }
        }
        return response;
    }

    function isBrandAlreadyExists(list, candidate) {
        var response = false;
        if (list != undefined && list != null && list.length > 0) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].name === candidate) {
                    response = true;
                    break;
                }
            }
        }
        return response;
    }

    function isLicenseKeyAldreadyExists(list, candidate) {
        var response = false;
        for (var i = 0; i < list.length; i++) {
            if (list[i].license_key === candidate) {
                response = true;
                break;
            }
        }
    }

    function checkCandidateIpIsExists(list, startIp, endIp) {
        var response = false;
        for (var i = 0; i < list.length; i++) {
            if (checkIpIsInRange(list[i].start_ip, startIp, true)
                && checkIpIsInRange(list[i].end_ip, endIp, false)) {
                response = true;
                break;
            }
        }
        return response;
    }

    function checkIpIsInRange(storedIp, paramIp, isStart) {
        var response = true;
        storedIp = storedIp.split('.');
        paramIp = paramIp.split('.');
        for (var i = 0; i < storedIp.length; i++) {
            if (i < storedIp.length - 1) {
                if (!(parseInt(storedIp[i]) == parseInt(paramIp[i]))) {
                    response = false;
                    break;
                }
            } else {
                if (isStart) {
                    if (!(parseInt(storedIp[i]) <= parseInt(paramIp[i]))) {
                        response = false;
                    }
                } else {
                    if (!(parseInt(storedIp[i]) >= parseInt(paramIp[i]))) {
                        response = false;
                    }
                }
            }
        }
        return response;
    }

    function readCSV(self, csv, tableType) {
        self.bulkInsertEleminateCount = 0;
        var reader = new FileReader();
        reader.readAsText(csv);
        reader.onload = function (event) {
            if (tableType == TABLE_TYPE_IP) {
                ipCSVtoJSON(self, reader.result);
            } else if (tableType == TABLE_TYPE_DOMAIN) {
                domainCSVtoJSON(self, reader.result);
            } else {
                brandCSVtoJSON(self, reader.result);
            }

        };
        reader.onerror = function (error) {
            self.partnerLoading = false;
        };
    }

    function brandCSVtoJSON(self, csv) {
        self.partnerLoading = true;
        var lines = csv.split("\n");
        var result = [];

        var brandList = self.$refs.brandListDatatable.getTableData();

        for (var i = 0; i < lines.length; i++) {
            var brand = lines[i].trim();
            if (brand != undefined && brand != null && brand != '') {
                if (!isBrandAlreadyExists(brandList, brand)
                    && result.indexOf(brand) == -1) {
                    result.push(brand);
                } else {
                    self.bulkInsertEleminateCount = self.bulkInsertEleminateCount + 1;
                }
            } else {
                self.bulkInsertEleminateCount = self.bulkInsertEleminateCount + 1;
            }
        }
        if (result.length > 0) {
            var body = {
                brands: result,
                enterprise_id: self.selectedPartner.value
            };
            addRequest(self, TABLE_TYPE_BRAND, END_POINT_BRAND_ADD_BULK, body);
        } else {
            self.partnerLoading = false;
            self.$toasted.show("Inputs are malformed or already exists, please check csv file!", {
                position: "bottom-center",
                duration: 5000,
                type: 'error'
            });
        }
    }

    function domainCSVtoJSON(self, csv) {
        self.partnerLoading = true;
        var lines = csv.split("\n");
        var result = [];

        var domainList = self.$refs.domainListDatatable.getTableData();
        for (var i = 0; i < lines.length; i++) {
            let domain = lines[i].trim();
            if (domain != undefined && domain != null && domain != ''
                && DOMAIN_FORMAT.test(domain)) {
                if (!isDomainAlreadyExists(domainList, domain) && result.indexOf(domain) == -1) {
                    var domainCsv = {domain: domain}
                    result.push(domain);
                } else {
                    self.bulkInsertEleminateCount = self.bulkInsertEleminateCount + 1;
                }
            } else {
                self.bulkInsertEleminateCount = self.bulkInsertEleminateCount + 1;
            }
        }
        if (result.length > 0) {
            var body = {
                domains: result,
                enterprise_id: self.selectedPartner.value
            };
            addRequest(self, TABLE_TYPE_DOMAIN, END_POINT_DOMAIN_ADD_BULK, body);
        } else {
            self.partnerLoading = false;
            self.$toasted.show("Inputs are malformed or already exists, please check csv file!", {
                position: "bottom-center",
                duration: 5000,
                type: 'error'
            });
        }
    }

    function ipCSVtoJSON(self, csv) {
        self.partnerLoading = true;
        var lines = csv.split("\n");
        var result = [];

        var ipList = self.$refs.ipListDatatable.getTableData();

        for (var i = 0; i < lines.length; i++) {
            var obj = {};
            var currentline = lines[i].split(";");
            if (currentline[0] != undefined && currentline[0] != null) {
                obj['start_ip'] = currentline[0].trim();
            }
            if (currentline[1] != undefined && currentline[1] != null) {
                obj['end_ip'] = currentline[1].trim();
            }

            if (obj.start_ip != undefined && obj.start_ip != null && IP_FORMAT.test(obj.start_ip.trim())
                && (obj.end_ip == undefined || obj.end_ip == null)) {
                obj['end_ip'] = obj['start_ip'];
            }

            if (obj.start_ip != undefined && obj.start_ip != null && IP_FORMAT.test(obj.start_ip.trim()) &&
                obj.end_ip != undefined && obj.end_ip != null && IP_FORMAT.test(obj.end_ip.trim())) {
                if (!checkCandidateIpIsExists(ipList, obj.start_ip, obj.end_ip)
                    && !checkCandidateIpIsExists(result, obj.start_ip, obj.end_ip)) {
                    result.push(obj);
                } else {
                    self.bulkInsertEleminateCount = self.bulkInsertEleminateCount + 1;
                }
            } else {
                self.bulkInsertEleminateCount = self.bulkInsertEleminateCount + 1;
            }
        }
        if (result.length > 0) {
            var body = {
                ips: result,
                enterprise_id: self.selectedPartner.value
            };
            addRequest(self, TABLE_TYPE_IP, END_POINT_IP_ADD_BULK, body);
        } else {
            self.partnerLoading = false;
            self.$toasted.show("Inputs are malformed or already exists, please check csv file!", {
                position: "bottom-center",
                duration: 5000,
                type: 'error'
            });
        }
    }
</script>

<style>

    .settings-datatable {
        height: calc(100%) !important;
        overflow: hidden !important;
    }

    .settings-datatable > div > .table-responsive > table > tbody {
        height: calc(100vh - 360px) !important;
    }

    .settings-datatable > div > .table-responsive > .datatable-collapsed > tbody {
        height: calc(100vh - 420px) !important;
    }

    .vendor-select {
        position: relative;
        top: 30px;
    }

    .av-vendor-radio-button {
        display: inline-block !important;
        margin-right: 20px !important;
        margin-bottom: 20px !important;
        width: 265px !important;
        height: 30px !important;
        font-family: 'Digital-Serial-Regular';
        color: rgba(0, 255, 169, 1) !important;
    }

    .container {
        position: relative !important;
        padding-left: 35px !important;
        margin-bottom: 12px !important;
        cursor: pointer !important;
        font-size: medium !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    #fileInput {
        display: none;
    }

    #settings-page {
        position: relative;
        background-color: black;
        height: 94%;
        min-width: 940px;
    }

    .action-button {
        font-family: 'Digital-Serial-Bold';
        position: absolute;
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 120px !important;
        font-weight: bold;
    }

    .select-partner-drop-down {
        font-family: 'Digital-Serial-Bold';
        position: absolute;
        background-color: #80d700;
        border: none;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 350px;
        font-weight: bold;
        color: black;
        left: 110px;
        top: 10px;
        align-items: flex-start;
        text-align: left;
    }

    .select-partner-label {
        font-family: 'Digital-Serial-Bold';
        position: absolute;
        background-color: #93fa00;
        border: none;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 100px;
        font-weight: bold;
        color: black;
        left: 0;
        align-items: flex-start;
        text-align: center;
        top: 10px;
    }

    .partner-option {
        font-family: 'Digital-Serial-Bold';
        background-color: #00FE17;
        border: none;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 100px;
        font-weight: bold;
        color: black;
        left: 0;
        align-items: flex-start;
        text-align: center;
    }

    .action-button-big {
        width: 140px;
    }

    .upload-button {
        top: 80px !important;
        right: 150px !important;
    }

    .add-button {
        top: 80px !important;
        right: 20px !important;
    }

    .add-partner-button {
        padding: 0px;
        top: 10px !important;
        right: 20px !important;
    }

    .edit-partner-button {
        padding: 0px;
        top: 10px !important;
        right: 150px !important;
    }

    .add-notification-button {
        top: 80px !important;
        right: 20px !important;
        width: 200px !important;
    }

    .vendor-save-changes {
        font-family: 'Digital-Serial-Bold';
        position: absolute;
        background-color: rgb(117, 32, 250);
        border: none;
        color: white;
        line-height: 40px;
        font-size: 14px;
        max-height: 40px;
        height: 40px;
        width: 140px !important;
        font-weight: bold;

    }

    .settings-content {
        border-top: 10px solid #1b2129;
        height: calc(100vh - 60px) !important;
    }

    .settings-partner-content {
        height: 60px;
    }

    .hsy-dropdown {

    }

    .hsy-dropdown > .selected {
        border-radius: 3px !important;
        padding: 0 30px 0 10px !important;
        color: white !important;
        cursor: pointer !important;
        background: url("../assets/menu-arrow.svg") no-repeat 100% !important;
        background-position-x: calc(100% - 10px) !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        border: 0 !important;
        align-items: flex-start !important;
        text-align: left !important;
        line-height: 40px !important;
        font-size: 14px !important;
        max-height: 40px !important;
        height: 40px !important;
        width: 350px !important;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .hsy-dropdown > .list .item {
        height: 40px !important;
        line-height: 40px !important;
        padding: 0 10px !important;
        cursor: pointer !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        background-position: 5px !important;
        text-align: left !important;
        margin-bottom: 1px !important;
        color: white !important;
        border-bottom: 1px solid #00fea9 !important;
        font-size: 14px !important;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .hsy-dropdown > .list .item:nth-of-type(odd) {
        background-color: #0a0b0c !important;
    }

    .hsy-dropdown > .list .item:nth-of-type(even) {
        background-color: rgb(16, 20, 26) !important;
    }

    .hsy-dropdown > .list {
        position: absolute !important;
        top: 35px !important;
        left: 0 !important;
        font-size: 1.2em !important;
        box-shadow: 0 0 5px rgba(0, 0, 0, .2) !important;
        border-radius: 1px !important;
        z-index: 100 !important;
        background-color: black !important;
        border: 1px solid #00fea9 !important;
        font-family: 'Digital-Serial-Bold' !important;
        max-height: 300px !important;
        overflow-y: auto !important;
    }

    .hsy-dropdown > .list .item.selected {
        background: #00fea9 no-repeat 10px !important;
        border-radius: 3px !important;
        color: black !important;
        padding-left: 20px !important;
        width: 100% !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .hsy-dropdown > .list > .inner {
        padding: 2px 2px 0px 2px !important;
    }

    .partner-loading-modal-container {
        height: calc(100%);
        width: calc(100%);
        z-index: 10;
    }

    div.disabled {
        pointer-events: none;
        opacity: 0.5;
        background: black;
    }

    .hsy-dropdown ::-webkit-scrollbar {
        display: none;
    }

    .api-key-container {
        border: 1px solid rgba(255, 0, 67, 1);
        width: 33%;
        height: 30px;
        position: absolute;
        z-index: 1 !important;
    }

    .api-key-header {
        background-color: rgba(255, 0, 67, 1);
        color: white;
        font-family: 'Digital-Serial-Bold';
        height: 100%;
        width: 20%;
        padding: 5px;
        text-align: center;
        position: absolute;
    }

    .api-key-value {
        color: white;
        font-family: 'Digital-Serial-Bold';
        height: 100%;
        margin-left: 20%;
        padding-left: 5px;
        padding-top: 5px;
    }

    .export-button {
        right: 170px !important;
        position: absolute;
    }

    #disableAddButtons {
        opacity: 0.3;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Settings.vue